import { ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Chapter, FadeUp } from "@/components/Reveal";

export default function Restructuration() {
  return (
    <div className="bg-slate-50 min-h-screen flex flex-col" data-testid="restructuration-page">
      <Navbar />
      <main className="flex-1">
        <section className="bg-slate-900" data-testid="restructuration-hero">
          <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-24 sm:py-28 lg:py-32">
            <FadeUp>
              <Chapter index="01" label="Restructuration & Retournement" />
            </FadeUp>
            <FadeUp delay={0.1}>
              <h1
                className="mt-8 max-w-3xl font-sans font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight"
                data-testid="restructuration-title"
              >
                Sécuriser la survie. Reconstruire sur des bases saines.
              </h1>
            </FadeUp>
            <FadeUp delay={0.2}>
              <p
                className="mt-8 max-w-2xl text-base sm:text-lg text-slate-300 leading-relaxed"
                data-testid="restructuration-intro"
              >
                Face à une crise de liquidité ou une perte brutale de rentabilité, l'analyse
                comptable descriptive ne suffit plus. Là où le contrôle de gestion traditionnel
                optimise les budgets en temps de paix, ACS Corporate déploie une ingénierie
                financière de temps de crise. Nous intervenons pour réaliser un audit systémique
                de l'entreprise en difficulté, en dépassant les chiffres pour mettre en lumière
                l'impact des décisions managériales, des contraintes économiques et du contexte
                de marché.
              </p>
            </FadeUp>
            <FadeUp delay={0.3}>
              <div
                data-testid="reserved-image-block"
                className="mt-14 aspect-video w-full rounded-2xl border border-dashed border-slate-700 bg-slate-800/50 flex items-center justify-center"
              >
                <span className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
                  Espace réservé — visuel à venir
                </span>
              </div>
            </FadeUp>
          </div>
        </section>

        <section className="bg-slate-50" data-testid="restructuration-methodologie">
          <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-24 sm:py-28 lg:py-32">
            <FadeUp>
              <Chapter index="02" label="Méthodologie" />
            </FadeUp>
            <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-start">
              <FadeUp className="lg:col-span-5">
                <h2 className="font-sans font-extrabold text-slate-900 text-3xl sm:text-4xl leading-[1.15] tracking-tight">
                  Notre Méthodologie d'Investigation
                </h2>
              </FadeUp>
              <FadeUp delay={0.15} className="lg:col-span-7">
                <p className="w-full break-words whitespace-normal text-base sm:text-lg text-gray-600 leading-relaxed">
                  Notre investigation permet de déceler les erreurs de gestion passées, les
                  rigidités structurelles, et d'isoler les poches de rentabilité qui ont résisté
                  à la crise. C'est cette mise en contraste stricte entre la donnée brute, la
                  problématique du marché et notre expertise de Direction Générale qui nous
                  permet de délivrer des recommandations opérationnelles poussées. Nous
                  construisons les dossiers financiers complets qui prouveront la viabilité de
                  l'entreprise face aux partenaires et aux Tribunaux de Commerce.
                </p>
                <a
                  href="/#contact"
                  data-testid="restructuration-cta"
                  className="group mt-10 inline-flex items-center gap-2 bg-slate-900 text-white px-8 py-4 rounded-full font-medium hover:bg-slate-700 transition-colors duration-300"
                >
                  Confier un dossier
                  <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                </a>
              </FadeUp>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
